app.registerLib('mediator', function(app) {

	return {

        consoleLogEvents: false,
        eventLog: [],
		handlers: {}, // Contains event handlers
		modules: {}, // Contains all registered UI fragments

        // Registers a UI fragment module into the modules object
		registerModule: function(modKey, modConstructorFunc) {
			this.modules[modKey] = modConstructorFunc(app);
		},

        // Notifies each module that a resource has loaded, and lets
        // each module individually decide how to react
        onLoaded: function (data) {
            var scope = this;
			Object.keys(this.modules).forEach(function(moduleKey) {
				var module = scope.modules[moduleKey];
				if (typeof module.onLoaded == 'function') {
				    module.onLoaded(data);
				}
			});
        },

	    // Iterates all registered UI fragment modules, and calls
        // its init() method, if it exists.
		initAll: function() {
			var scope = this;
			Object.keys(this.modules).forEach(function(modKey) {
				var module = scope.modules[modKey];
				if (typeof module.init == 'function') {
				    module.init();
				}
			});
		},

	    // Iterates all registered UI fragment modules, and calls
        // its init() method, if it exists.
		deinitAll: function() {
			var scope = this;
			Object.keys(this.modules).forEach(function(modKey) {
				var module = scope.modules[modKey];
				if (typeof module.deinit == 'function') {
					module.deinit();
				};
			});
		},

        // Calls the init method on the module registered to this object that has a key of modKey.
		init: function(modKey) {
		    if (typeof this.modules[modKey].init == 'function') {
		        this.modules[modKey].init();
		    }
		},

        // Calls the deinit method on the module registered to this object that has a key of modKey.
		deinit: function(modKey) {
			if (typeof this.modules[modKey].deinit == 'function') {
				this.modules[modKey].deinit();
			}
		},

        getMostRecentBroadcastOf: function(eventName) {
            var found = null;
            this.eventLog.forEach(function(event) {
                if (event.eventName == eventName) {
                    found = event.args;
                }
            });
            return found;
        },

	    // Registers a mediator event listener into the mediator.
	    // The listenFor argument is a key, the callback is the function that should be
        // executed in response. Module logs which module registered the listener.
		addListener: function(listenFor, callback, module, removeOnceCalled) {
			removeOnceCalled = typeof removeOnceCalled !== 'undefined' ? removeOnceCalled : false;
			if (!this.handlers[listenFor]) {
				this.handlers[listenFor] = [];
			}
			var data = {
				callback: callback,
				removeOnceCalled: removeOnceCalled
			}
			if (typeof module != 'undefined') {
				data.module = module;
			}
			this.handlers[listenFor].push(data);
		},

        // Works like 'notify', but with two differences:
        // 1. The callback will be run immediately if an event with the specified listenFor event name
        // has occurred in the past.
        // 2. If an event with the specified listenFor event name has not already happened yet,
        // the event will only be broadcast once.
        awaitOnce: function(listenFor, callback, module) {
            var scope = this;
            var mostRecentEventArgs = this.getMostRecentBroadcastOf(listenFor);
            if (mostRecentEventArgs) {
                if (scope.consoleLogEvents) console.log('Responding to previously logged event: ' + listenFor);
                callback.apply(module, mostRecentEventArgs);
            } else {
                scope.addListener(listenFor, callback, module, true);
            }
        },
		
        // Loops through all registered mediator event handlers, and calls them.
		notify: function() {
			var listenFor = arguments[0];
            if (this.consoleLogEvents) console.log('Event just fired: ' + listenFor);
			var args = Array.prototype.slice.call(arguments, 1);
            this.eventLog.push({
                eventName: listenFor,
                args: args
            });
			var returned;
			var returnedCollection;
			if (this.handlers[listenFor] instanceof Array) {
				for (var i = 0; i < this.handlers[listenFor].length; i++) {
					returned = this.handlers[listenFor][i].callback.apply(this.handlers[listenFor][i].module, args);
					if (returned) {
						returnedCollection.push(returned);
					}
					if (this.handlers[listenFor][i].removeOnceCalled) {
                    	this.handlers[listenFor].splice(i, 1);
					}
				}
			}
			return returnedCollection;
		},

		getModule: function (modKey) {
		    return this.modules[modKey];
		},

		hasModule: function (modKey) {
		    return typeof this.modules[modKey] !== 'undefined';
		}
	};

});
